import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NumberService {
  formatCurrency(value: number): string {
    return new Intl.NumberFormat('sl-SL', {
      style: 'currency',
      currency: 'EUR',
    }).format(value);
  }

  formatNumber(value: number): string {
    return new Intl.NumberFormat('sl-SL', {
      maximumSignificantDigits: 2,
    }).format(value);
  }
}
